enum TecnicaDaCirurgiaEnum {
  Robotica = 'Robotica',
  Video = 'Video',
  Convencional = 'Convencional',
}

export default TecnicaDaCirurgiaEnum
